import React from 'react'
String.prototype.sanitize = function () {
    return this === undefined || this === null ? '' : this.replace(/'/gi, "\\\'").normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
export function set_content_type()  
{
    try {
        // TODO
    }catch(errr){}
}
export function track_click($tag_name)
{
    window.dataLayer && window.dataLayer.push({ 
        event : 'other', 
        promo_type : 'other', 
        promo_loc : 'https://www.univision.com' + process.env.PREFIX_PATH, 
        promo_name : $tag_name
    });
}
export function track_social_click(data) {
    const tracking_data = getTrackingObject();
    typeof window !== 'undefined' && window.dataLayer && dataLayer.push({
      event_action: data.social_name,
      event_label: tracking_data.content_id + ' - ' + data.title.sanitize(),
      event: 'social_share',
      promo_type: 'link',
      promo_loc: tracking_data.permalink,
      environment_name: 'production'
    });
}
export function getTrackingObject() {
    var tracking_data = window._get("tracking");
    return tracking_data ? JSON.parse(tracking_data) : {};
}
export default class Tracking extends React.Component {

    track_event(text)
    {
        console.log("hola hola " + text)
    }
    init_track(w,d,s,l,i)
    {
        w[l]=w[l]||[];w[l].push(window.utag_data);w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    }
    track(tracking_data) {
        if(tracking_data !== undefined) {
            tracking_data.title = 'Te explicamos - ' + this.props.trackTitle;
            
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(window.tracking_data);w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TDVV9BR');
        }
    }
    componentDidMount()
    {
        setTimeout(() => {
            var tracking_data = window._get("tracking"); 
            window.tracking_data = tracking_data ? JSON.parse(tracking_data) : {};+
            this.track(window.tracking_data);
        }, 600);
    }
    render() {
        return <div id="tracking-utag">
               </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/tracking.js